<template>
    <router-view></router-view>
</template>

<script>
    export default {
        data() {
            return {
                allowedRoutes: [
                    'account.activate',
                    'password.recover',
                    'password.reset',
                    'report.show',
                    'register',
                    'visualization.show',
                    'visualization.embed',
                ]
            }
        },
        created() {
            if (!this.allowedRoutes.includes(this.$router.currentRoute.name)) {
                this.$router.push({ name: 'login'});
            }
        },
        methods: {

        }
    }
    
</script>
